import { NavLink } from 'react-router-dom';
import TenantLogoImage from '@/components/common/TenantLogoImage';
import { ORG_HOME_PATH } from '@/utils/orgConsole';

type OrgContextBadgeProps = {
  orgName?: string | null;
  logoUrl?: string | null;
};

export default function OrgContextBadge({ orgName, logoUrl }: OrgContextBadgeProps) {
  const name = orgName?.trim() || 'Organization';
  const letter = name.charAt(0).toUpperCase();

  return (
    <NavLink
      to={ORG_HOME_PATH}
      className="flex items-center gap-2 shrink-0 max-w-[220px] sm:max-w-[280px] rounded-lg border border-border bg-[var(--topbar-input-bg)] px-2.5 py-1.5 hover:bg-surface-hover transition-colors"
      title={name}
    >
      {logoUrl ? (
        <TenantLogoImage
          src={logoUrl}
          alt=""
          className="h-7 w-7 shrink-0 rounded-md object-contain"
          fallback={
            <span
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-[12px] font-bold"
              style={{ background: 'var(--project-icon-bg)', color: 'var(--project-icon-text)' }}
            >
              {letter}
            </span>
          }
        />
      ) : (
        <span
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-[12px] font-bold"
          style={{ background: 'var(--project-icon-bg)', color: 'var(--project-icon-text)' }}
        >
          {letter}
        </span>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-[.06em] text-text-muted leading-none mb-0.5">
          Organization
        </p>
        <p className="text-[12px] font-semibold text-text-primary truncate leading-tight">{name}</p>
      </div>
    </NavLink>
  );
}
